<template>
	<div id="PageTest">
		<pre>{{ $route.meta }}</pre>
		<pre>{{ $route.params }}</pre>
		<pre>{{ $route.name }}</pre>

		<router-view />

		<pre>{{ $store.getters["orm/translations"] }}</pre>


	</div>
</template>

<script>

import { mapGetters } 	from 'vuex'

import formatter 		from '@/store/orm/helpers/formater';
export default {
	name: 'PageTest',
	data() {
		return{
			formatter,
			today1: 	new Date(2018,1, 1, 8),
			today2: 	new Date(2018,1, 1, 10),
			tomorrow: 	new Date(2018, 1, 2, 10)
		};

	},
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageTest.vue